import EventEmitter from './EventEmitter';
class Mask extends EventEmitter {
    _value = 0;
    constructor(value) {
        super();
        this._value = value || this._value;
    }
    _onChange() {
        this.emit('change', this);
    }
    merge(value) {
        this._value |= value;
        this._onChange();
        return this._value;
    }
    exclude(value) {
        this._value & ~value;
        this._onChange();
        return this._value;
    }
    has(value) {
        return this._value & value;
    }
    getValue() {
        return this._value;
    }
    static createFrom(value) {
        const mask = new Mask(0);
        value.forEach(value => mask.merge(value));
        return mask;
    }
}
export default Mask;
